// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3dqEk","title":"ClientCherryInfo_title__J5hNq","itemText":"ClientCherryInfo_itemText__3MQjh"};